import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageBusinessReserveCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Reserve Business Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-reserve-card.png',
  show: true,
  position: 'right'
};

export const BannerContentBusinessReserveCardMocks: GenericLabel = {
  title: 'Delta SkyMiles® Reserve Business Card Member',
  subtitle: ''
};

export const BannerBusinessReserveCardMocks: CardCarouselBanner = {
  labels: BannerContentBusinessReserveCardMocks,
  image: BannerImageBusinessReserveCardMocks
};
